<script setup lang="ts">
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'
import { useGetAllFavorites } from '~~/src/composables/useGetAllfavorites'
import ElementalsAccordionList from '@/components/DrawerSidebarRight/components/ElementalsAccordionList/index.vue'
import type { AccordeonEmits } from '@/components/Accordion/index.vue'

const emits = defineEmits<AccordeonEmits>()
const { elementalsFiltered, isLoading, error, refetch } = useGetAllFavorites()
const user = useUser()
const { state, toggleFavoriteAccordion } = useElementalListsStore()

const handleClose = () => {
  toggleFavoriteAccordion(false)
}

const handlerOpen = () => {
  toggleFavoriteAccordion(true)
}

const handleToggle = (isOpen?: boolean) => {
  emits('onToggle', isOpen)
}

onMounted(() => {
  refetch()
})
</script>

<template>
  <div v-if="user">
    <ElementalsAccordionList
      title="Favorites"
      icon-class="bg-[#F8CB4F] h-7 w-7"
      icon-name="i-mdi:star-outline text-[#F8CB4F]"
      :elementals="elementalsFiltered || []"
      :is-open="state.favoriteAccordionOpen"
      :is-loading="isLoading"
      :columns="['title', 'description', 'actions']"
      :folder-level="2"
      row-class="border-b border-grayLighter"
      @on-close="handleClose"
      @on-open="handlerOpen"
      @on-toggle="handleToggle"
    />
  </div>
</template>
